import { Title } from '../../components/Title/Title';
import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useEffect, useState } from 'react';
import { innerHtml } from '../../utils/utils';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';

const Contacts = () => {
    const { getLegal } = useFirebase();
    const { t } = useTranslation();
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getLegal('contacts')
            .then(({ content }) => {
                setContent(content);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <FullscreenLoader fullscreen={true} />;

    return (
        <AppShell>
            <div className="d-flex flex-column flex-grow-1">
                <Title>{t('legalese.labels.contactUs')}</Title>

                <Container className="flex-grow-1">
                    <div {...innerHtml(content)}></div>
                </Container>

                <Footer />
            </div>
        </AppShell>
    );
};

export default Contacts;
